import { render, staticRenderFns } from "./xiangxiwt.vue?vue&type=template&id=5386ec5a&scoped=true"
import script from "./xiangxiwt.vue?vue&type=script&lang=js"
export * from "./xiangxiwt.vue?vue&type=script&lang=js"
import style0 from "./xiangxiwt.vue?vue&type=style&index=0&id=5386ec5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5386ec5a",
  null
  
)

export default component.exports